import { styled } from 'styled-components';

import { cssBreakpoints } from '#/theme/theme';

export const NoJobsMatch_Box_1 = styled.div`
  padding-block: 12px;
  padding-inline: 24px;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    padding-block: 24px;
    padding-inline: 44px;
  }
`;
